'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlPchar = require('./validateUrlPchar');

var _validateUrlPchar2 = _interopRequireDefault(_validateUrlPchar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlQuery = (0, _regexSupplant2.default)(/(#{validateUrlPchar}|\/|\?)*/i, {
  validateUrlPchar: _validateUrlPchar2.default
});
exports.default = validateUrlQuery;
module.exports = exports['default'];